<template>
  <el-row v-loading="loading" class="shared-booking p-3">
    <el-row class="title mb-3" type="flex" align="middle" justify="space-between">
      <h3 class="m-0">
        CẤU HÌNH BOOKING: {{ detail && detail.name ? detail.name.toUpperCase() : '' }}
      </h3>
      <span v-if="detail && detail.updated_at" class="text-muted font-size-sm">
        Cập nhật lần cuối: {{ detail.updated_at }}
      </span>
    </el-row>

    <!-- Bước 2: Hiển thị Form Setup nếu chưa có booking (Thu nhỏ 1/3 ~ span 8) -->
    <div v-if="!loading && !isSetup">
      <el-row type="flex" justify="start">
        <el-col :xs="24" :sm="16" :md="12" :lg="8">
          <booking-setup-form
            :detail="detail"
            @setup-success="handleSetupSuccess"
          />
        </el-col>
      </el-row>
    </div>

    <!-- Bước 3: Hiển thị 4 Cards thông tin sắp xếp theo Row & Col 2 cột -->
    <div v-if="!loading && isSetup && currentProduct">
      <el-row :gutter="16">
        <!-- Cột trái: Card 1 (Thông tin chung) & Card 2 (Cấu hình giá) -->
        <el-col :xs="24" :lg="12">
          <product-general-info
            :product="currentProduct"
            :detail="detail"
            @product-updated="handleProductUpdated"
            @product-deleted="handleProductDeleted"
          />

          <product-prices
            :product="currentProduct"
          />
        </el-col>

        <!-- Cột phải: Card 3 (Slot mở bán vé) & Card 4 (Danh sách câu hỏi) -->
        <el-col :xs="24" :lg="12">
          <product-capacities
            :product="currentProduct"
          />

          <product-questions
            :product="currentProduct"
          />
        </el-col>
      </el-row>
    </div>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex'
import { getProductById } from '@/services/product'
import BookingSetupForm from './booking/BookingSetupForm.vue'
import ProductGeneralInfo from './booking/ProductGeneralInfo.vue'
import ProductPrices from './booking/ProductPrices.vue'
import ProductCapacities from './booking/ProductCapacities.vue'
import ProductQuestions from './booking/ProductQuestions.vue'

export default {
  name: 'SharedBooking',
  components: {
    BookingSetupForm,
    ProductGeneralInfo,
    ProductPrices,
    ProductCapacities,
    ProductQuestions
  },
  props: {
    data: Object,
    detail: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      isSetup: false,
      currentProduct: null
    }
  },
  computed: {
    ...mapGetters(['language', 'accountOrg'])
  },
  watch: {
    detail: {
      immediate: true,
      handler(newVal) {
        if (newVal && (newVal.id || newVal._id)) {
          this.checkBookingSetup()
        } else {
          this.loading = false
        }
      }
    }
  },
  methods: {
    checkBookingSetup() {
      if (!this.detail || (!this.detail.id && !this.detail._id)) {
        this.loading = false
        return
      }

      const detailId = this.detail.id || this.detail._id
      let productId = null

      try {
        const stored = localStorage.getItem('shared_booking_products')
        if (stored) {
          const mappings = JSON.parse(stored)
          const found = mappings.find((item) => String(item.detail_id) === String(detailId))
          if (found) {
            productId = found.product_id
          }
        }
      } catch (e) {
        console.error('Lỗi khi đọc shared_booking_products từ localStorage:', e)
      }

      if (!productId) {
        this.isSetup = false
        this.currentProduct = null
        this.loading = false
        return
      }

      this.loading = true
      getProductById(productId).then((res) => {
        const productData = res.data || res
        if (productData && (productData.id || productData._id)) {
          this.currentProduct = productData
          this.isSetup = true
        } else {
          this.isSetup = false
          this.currentProduct = null
        }
      }).catch(() => {
        // Fallback: If API getProductById fails, setup flag reset
        this.isSetup = false
        this.currentProduct = null
      }).finally(() => {
        this.loading = false
      })
    },

    handleSetupSuccess(product) {
      this.currentProduct = product
      this.isSetup = true
    },

    handleProductUpdated(updatedProduct) {
      this.currentProduct = { ...updatedProduct }
    },

    handleProductDeleted() {
      this.currentProduct = null
      this.isSetup = false
    }
  }
}
</script>

<style lang="scss" scoped>
.shared-booking {
  min-height: 800px;
  margin-bottom: 24px;
}
.text-muted {
  color: #909399;
}
.font-size-sm {
  font-size: 13px;
}
</style>
<style lang="scss">
.shared-booking {
  /* width */
  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
    border-radius: 5px;
  }
}
</style>
